import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loading from '../layout/Loading';

const PrivateRoute = ({ children, isAuthenticated, loading }) => {
  const location = useLocation();
  const hasToken = !!localStorage.token;

  // Function to save the original URL and redirect to it after login
  const saveAndRedirect = () => {
    if (location.pathname !== '/login') {
      const redirectPath = location.pathname + location.search;
      localStorage.setItem('redirectAfterLogin', redirectPath);
    }
    return <Navigate to='/login' replace />;
  };

  if (!hasToken) {
    return saveAndRedirect();
  }

  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return saveAndRedirect();
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
});

export default connect(mapStateToProps)(PrivateRoute);